export const LocationSummary = {
  // location summary
  GET_LOCATION_SUMMARY: "GET_LOCATION_SUMMARY",
  GET_LOCATION_SUMMARY_SUCCESS: "GET_LOCATION_SUMMARY_SUCCESS",
  GET_LOCATION_SUMMARY_FAILURE: "GET_LOCATION_SUMMARY_FAILURE",

  // reset location summary
  RESET_LOCATION_SUMMARY: "RESET_LOCATION_SUMMARY",

  // landmark nearby modal
  OPEN_LANDMARK_NEARBY_MODAL: "OPEN_LANDMARK_NEARBY_MODAL",
  CLOSE_LANDMARK_NEARBY_MODAL: "CLOSE_LANDMARK_NEARBY_MODAL",
};
